<template>
  <div>
    <loading-spinner />
    <iframe
      v-if="getCampaignContent"
      id="template-iframe"
    />
    <empty-state
      v-if="!getLoadingStatus && (!getCampaignContent || getCampaignContent === &quot;&quot;)"
      icon="browser"
      description="No Template has been associated to this campaign"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import LoadingSpinner from '../components/LoadingSpinner'
import EmptyState from '../components/EmptyState'

export default {
  components: {
    LoadingSpinner,
    EmptyState
  },
  data () {
    return {
      templateEmpty: false
    }
  },
  computed: {
    ...mapGetters([
      'getCampaignContent',
      'getLoadingStatus'
    ])
  },
  mounted () {
    const parentCompanyId = this.$route.query.clientId
    const projectId = this.$route.query.campaignId
    const userEmail = atob(this.$route.query.userEmail)
    if (projectId) {
      this.$store.dispatch('setCampaignContent', { parentCompanyId, projectId, userEmail })
        .then(response => {
          const iFrame = document.getElementById('template-iframe')
          iFrame.contentWindow.document.write(response.data)
        })
        .catch(error => {
          console.log(error)
        })
        .finally(() => {
          this.resizeIFrameToFitContent()
        })
    }
  },
  beforeDestroy () {
    this.$store.commit('SET_CAMPAIGN_CONTENT', ' ')
  },
  methods: {
    resizeIFrameToFitContent () {
      if (this.getCampaignContent) {
        setTimeout(() => {
          document.getElementById('template-iframe').height = document.getElementById('template-iframe').contentWindow.document.children[0].scrollHeight
        }, 1000)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.campaign-empty-state {
  text-align: center;
  svg {
    color: $secondary-light;
  }
}
#template-iframe {
  width: 100%;
  border: 0;
}
</style>
